var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareDiagonalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59032 10.5702L4.27969 9.65251L9.47358 2.23486L9.59604 2.05997L9.38329 2.07785L5.68133 2.38907L5.30044 0.98659L11.701 0.44849L13.3845 6.64712L11.9363 6.76887L10.9626 3.18372L10.9067 2.97768L10.7842 3.15258L5.59032 10.5702ZM13.9775 12.7892L0.0993496 12.8992L0.0993493 11.4884L13.9776 11.4884L13.9775 12.7892Z",
    fill: "currentFill",
    stroke: "transparent",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDiagonalIcon);
export default __webpack_public_path__ + "static/media/shareDiagonalIcon.0c2abd258998593b3b3c752aa8463e7b.svg";
export { ForwardRef as ReactComponent };